import { render, staticRenderFns } from "./qiniu-upload.vue?vue&type=template&id=160d0ef0"
import script from "./qiniu-upload.vue?vue&type=script&lang=js"
export * from "./qiniu-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports